<template>
  <main class="basicinfo">
    购买企业成员课程页面
  </main>
</template>

<script>
export default {
  name: 'EntMemberClass'
}
</script>

<style>

</style>